import { BRP_MARKET_PROGRAM_TYPES } from '@/constants/marketPrograms'

import { convertToStandardMarketProgramType } from './convertToStandardMarketProgramType'

/**
 * BRP billing-line programs (e.g. WHOLESALE_FEES, DAY_AHEAD) are not capacity/energy
 * markets: their sold capacity and activated energy are always 0. Whether they count as
 * revenues or costs is a separate concern — see isFeeMarketProgram.
 */
export function isBrpMarketProgram(marketProgram: string): boolean {
  const standardType = convertToStandardMarketProgramType(marketProgram)

  return BRP_MARKET_PROGRAM_TYPES.some((brpProgram) => brpProgram === standardType)
}
